var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2H5C3.34315 2 2 3.34315 2 5V14.25H6C6.41421 14.25 6.75 14.5858 6.75 15C6.75 15.4142 6.41421 15.75 6 15.75H2V19C2 20.6569 3.34315 22 5 22H16.25V19C16.25 18.5858 16.5858 18.25 17 18.25C17.4142 18.25 17.75 18.5858 17.75 19V22H19C20.6569 22 22 20.6569 22 19V6.75H18C17.5858 6.75 17.25 6.41421 17.25 6C17.25 5.58579 17.5858 5.25 18 5.25H22V5C22 3.34315 20.6569 2 19 2H14.75V8.25H17C17.4142 8.25 17.75 8.58579 17.75 9V15C17.75 15.4142 17.4142 15.75 17 15.75H11.75V19C11.75 19.4142 11.4142 19.75 11 19.75H6C5.58579 19.75 5.25 19.4142 5.25 19C5.25 18.5858 5.58579 18.25 6 18.25H10.25V15C10.25 14.5858 10.5858 14.25 11 14.25H16.25V9.75H11.7073C11.735 9.82819 11.75 9.91234 11.75 10V12C11.75 12.4142 11.4142 12.75 11 12.75C10.5858 12.75 10.25 12.4142 10.25 12V10C10.25 9.91234 10.265 9.82819 10.2927 9.75H6C5.58579 9.75 5.25 9.41421 5.25 9V5C5.25 4.58579 5.58579 4.25 6 4.25H9C9.41421 4.25 9.75 4.58579 9.75 5C9.75 5.41421 9.41421 5.75 9 5.75H6.75V8.25H13.25V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaze);
export default __webpack_public_path__ + "static/media/maze.75cf32fd421b49545397805b2f59c336.svg";
export { ForwardRef as ReactComponent };